import { createLogic } from "redux-logic";
import { getCart } from "../../../data/api";
import Constants from "../../../data/constants";
import { getCartId, getLocal, LOCAL_STORAGE_KEYS } from "../../../data/localStorageHelpers";
import { setCartData } from "../actions";
import { UPDATE_CART_DATA } from "../types";
import { updateCartStatus } from "../actions";
import { handleErrors } from "../../../data/helpers";
import { setInlineError } from "../../AppState/actions";
var updateCartLogic = createLogic({
    type: UPDATE_CART_DATA,
    latest: true,
    process: function (_a, dispatch, done) {
        var _b;
        var getState = _a.getState, action = _a.action;
        var _c = getState(), events = _c.events, cart = _c.cart, app = _c.app;
        if (events === null || events === void 0 ? void 0 : events.event) {
            var _d = events === null || events === void 0 ? void 0 : events.event, clientKey_1 = _d.clientKey, urlKey_1 = _d.urlKey, eventNumber_1 = _d.eventNumber, verbiage_1 = _d.verbiage;
            var updateCartAction_1 = action;
            if (eventNumber_1) {
                dispatch(updateCartStatus({ isLoading: true, timesLoaded: cart.cartStatus.timesLoaded }));
                getCart(getCartId(eventNumber_1), (_b = getLocal(LOCAL_STORAGE_KEYS.PROMO)) !== null && _b !== void 0 ? _b : undefined, eventNumber_1.toString())
                    .then(function (result) {
                    var data = result.data, status = result.status;
                    if (data.communityLimitExceeded) {
                        dispatch(setInlineError({ registerHeaderError: data.error }));
                    }
                    dispatch(setCartData(data));
                    if (status === 204) {
                        if (window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/") + 1) ===
                            Constants.Routes.questions
                                .replace(":clientKey", clientKey_1)
                                .replace(":urlKey", urlKey_1)
                                .replace(":eventNumber", eventNumber_1.toString())
                                .replace(Constants.Regex.guid, "")
                                .replace(":attendeeId?", "") ||
                            (window.location.pathname ===
                                Constants.Routes.cart
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString()) &&
                                (updateCartAction_1 === null || updateCartAction_1 === void 0 ? void 0 : updateCartAction_1.payload))) {
                            var url = (app.isAutoRegMode
                                ? Constants.Routes.autoreg
                                : verbiage_1 === "Tickets"
                                    ? Constants.Routes.tickets
                                    : Constants.Routes.register)
                                .replace(":clientKey", clientKey_1)
                                .replace(":urlKey", urlKey_1)
                                .replace(":eventNumber", eventNumber_1.toString());
                            updateCartAction_1.payload(url);
                        }
                    }
                })
                    .catch(function (error) {
                    //TODO handle these errors with some kind of global go back
                    dispatch(setCartData(undefined));
                    handleErrors(error, dispatch);
                })
                    .finally(function () {
                    dispatch(updateCartStatus({ isLoading: false, timesLoaded: cart.cartStatus.timesLoaded + 1 }));
                    done();
                });
            }
            else {
                done();
            }
        }
        else {
            done();
        }
    },
});
var exportable = [updateCartLogic];
export default exportable;
